export interface IPopupModal{
    show(): any;
    hide(): any;
}

export class PopupConfig {
    header: string;
    message: string;
    footer: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/popup-modals/popup-modal.class.ts